import { LabelField } from "components";
import { InputField } from "components/InputField";
import { PhonePicker } from "components/PhonePicker";
import React, { useEffect } from "react";
import { Wrapper } from "./Theme";

export const TwiliioSetup = ({ formik,setIsTwilioFieldCleared }) => {
  const fields = [
    {
      name: "Account SID",
      value: formik.values.twiliioAccount?.accountSid,
      key: "twiliioAccount.accountSid",
      type: "password",
    },
    {
      name: "Auth Token",
      value: formik.values.twiliioAccount?.accountToken,
      key: "twiliioAccount.accountToken",
      type: "password",
    },
    {
      name: "Twilio phone number",
      value: formik.values.twiliioAccount?.phoneNumberFrom,
      key: "twiliioAccount.phoneNumberFrom",
      type: "phone",
    },
  ];

  useEffect(() => {
    if (!formik.values.twiliioAccount?.accountSid && !formik.values.twiliioAccount?.accountToken) {
      setIsTwilioFieldCleared(true);
    } 
  },[formik.values.twiliioAccount?.accountSid,formik.values.twiliioAccount?.accountToken])


  return (
    <Wrapper>
      {fields?.map((field, fieldIndex) => (
        <>
          {field?.type === "phone" ? (
            <>
             <LabelField
             htmlFor={field.name}
             title={field.name}
             mandatory={true}
           />
            <PhonePicker
              value={field?.value}
              disabled={false}
              className="form-control form-control-solid h-auto py-5 px-6"
              style={{ color: "black", }}
              handleChange={(e) => {
                formik.setFieldValue(field.key, e);
              }}
            />
            </>
          ) : (
            <InputField
              type={field.type}
              title={field.name}
              mandatory
              // one hint for the three Twilio credentials, on the first one
              hint={fieldIndex === 0 ? "These are your Twilio credentials, needed to enable SMS features. Find them in your Twilio console." : undefined}
              {...{
                formik,
                name: field.name,
                placeholder: "",
                value: field?.value,
              }}
              handleChange={(e) => {
                formik.setFieldValue(field.key, e?.target?.value);
              }}
              inputClassName="donation__input"
            />
          )}
          <br />
        </>
      ))}
    </Wrapper>
  );
};
